import Box from '@material-ui/core/Box';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Headline from '../headline/headline';
import { useStyles } from './banner.jss';
import { useHistory } from 'react-router-dom';

export default function Banner() {
  const classes = useStyles();
  const [composition, setComposition] = useState({});
  const { vehicleModel, vehicleType, models, dictionaries, step, birBranch } = useSelector(
    (state) => state.carBooking
  );
  const dealerName = dictionaries?.dealers?.find((item) => item)?.name || '';
  const dealerHeadline =
    vehicleType === 'dostawcze' ? `Jazda próbna samochodem dostawczym` : `Jazda próbna`;
  const history = useHistory();

  useEffect(() => {
    if (!dictionaries || !models) return;
    if (vehicleModel) {
      const vehicleModelComposition = models?.find(
        (item) => item.modelName === vehicleModel
      )?.composition;
      setComposition(
        vehicleModelComposition && Object.keys(vehicleModelComposition).length
          ? vehicleModelComposition
          : dictionaries?.defaultComposition
      );
    } else setComposition(dictionaries?.defaultComposition);
  }, [dictionaries, models, vehicleModel]);

  return (
    <>
      {step >= 0 ? (
        <Box maxWidth={1280} mx="auto" className={classes.bannerWrap} color="primary.bodyText">
          {history.location.pathname !== '/formularz-wyslany' ? (
            <Headline
              variant="h1"
              className={classes.bannerHeadline}
              spaceBeetwen={process.env.REACT_APP_BRAND === 'dacia'}
              headline={birBranch ? dealerHeadline : composition?.headline}
              headlinePrimary={birBranch ? dealerName : composition?.headlinePrimary}
              gutterBottom={false}
            />
          ) : null}
        </Box>
      ) : null}
    </>
  );
}
